exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*  DEFINICION DE COLORES BASE */\ni.opcionLista {\n  cursor: pointer; }\ni.opcionLista.selected {\n  color: #14B7B3;\n  border: 1px solid #14B7B3;\n  border-radius: 13px;\n  background: white;\n  padding: 1px;\n  cursor: pointer; }\n.card-title {\n  color: black;\n  text-align: left;\n  margin-left: 14px; }\n.icon-info {\n  font-size: 17px;\n  vertical-align: text-top;\n  cursor: pointer !important; }\n.icon-accion {\n  position: absolute;\n  bottom: 14px;\n  right: 17px;\n  z-index: 99; }\n.text-green {\n  color: green; }\n.text-red {\n  color: #af1a1a; }\n.activo {\n  border-top: 4px solid green; }\n.inactivo {\n  border-top: 4px solid #af1a1a; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/auditoria/cmp-list-auditoria/css/list-auditoria.component.scss
// module id = ../../../../../src/app/layout/content/seguridad/auditoria/cmp-list-auditoria/css/list-auditoria.component.scss
// module chunks = main